<template>
  <div class="logo-company-box flex items-center justify-center">
    <img
      :src="`${noSave ? logoString : getUserLogo}`"
      alt="Company Logo"
      @error="$event.target.src = '/e/favicon192x192.png'"
    />
  </div>
</template>

<script>
import User from '@/apiClient/Users'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'ZtLogoCompany',
  props: {
    userId: {
      type: Number
    },
    noSave: {
      type: Boolean
    }
  },
  data() {
    return {
      user: '',
      logoString: '',
      isMounted: false
    }
  },
  computed: {
    ...mapState({
      getUserLogo(state) {
        return state.company.logo
      }
    })
  },
  methods: {
    ...mapActions({ getLogoCompany: 'getLogoCompany' }),

    getLogoCompanyNS(data) {
    this.logoString=  this.user
        .getCompanyLogo(data)
        
    }
  },
  async mounted() {
    this.user = new User()
    this.noSave
      ? await this.getLogoCompanyNS(this.userId)
      : this.getLogoCompany(this.userId)
  }
}
</script>

<style scoped lang="scss">
.logo-company-box {
  height: 100%;
  img {
    max-height: 100%;
    max-width: 100%;
  }
}
</style>
